export default __webpack_public_path__ + "static/media/P1_image2.46cf9f1b.png";